import { render, staticRenderFns } from "./suoritteen-kategoria-form.vue?vue&type=template&id=0b007bc8&scoped=true&"
import script from "./suoritteen-kategoria-form.vue?vue&type=script&lang=ts&"
export * from "./suoritteen-kategoria-form.vue?vue&type=script&lang=ts&"
import style0 from "./suoritteen-kategoria-form.vue?vue&type=style&index=0&id=0b007bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b007bc8",
  null
  
)

export default component.exports